module.exports = __webpack_public_path__ + "b3cf004de43fb6e55ab767718fff0cbe.pdf";